import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f603061"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = { class: "top-bar-content" }
const _hoisted_3 = { class: "top-bar-app-name" }
const _hoisted_4 = { class: "top-bar-module" }
const _hoisted_5 = { class: "search-input-container" }
const _hoisted_6 = { class: "user-area" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" }, null, -1))
const _hoisted_8 = {
  style: {"margin-left":"10px"},
  class: "user-area-name"
}
const _hoisted_9 = { style: {"margin-left":"5px"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" }, null, -1))

import {clearAccessToken, currentUser, loginViewShow, tenant} from "@/store";
import {Search, ArrowDown} from "@element-plus/icons-vue";
import {useRoute, useRouter} from "vue-router";
import {computed, onMounted, ref, watchEffect} from "vue";
import {searchText} from "@/store";



const __default__ = {
  name: "TopBar"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const topbarSearchText = ref<string>("")

const goMyCourseView = () => {
  router.push("/my_courses")
}
const goProfileView = () => {
  router.push("/profile")
}

const goGetBackPasswordView = () => {
  router.push({
    name: "GetBackPassword"
  })
}

const logout = () => {
  clearAccessToken()
  location.reload()
}

const logined = computed(() => {
  return currentUser.value != null
})

// watchEffect(() => {
//   if (tenant.value) {
//     document.title = tenant.value.name
//   }
// })


const route = useRoute()
const onEnter = () => {
  searchText.value = topbarSearchText.value
  if (route.path !== "/resources/search") {
    router.push({
      path: "/resources/search"
    })
  }
}



return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(tenant))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_avatar, {
                style: {"margin-right":"10px"},
                size: 30,
                fit: "cover",
                src: _unref(tenant).logo
              }, null, 8, ["src"]),
              _createElementVNode("span", null, _toDisplayString(_unref(tenant).name), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/home",
          class: "top-bar-module-name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 首页 ")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/resources",
          class: "top-bar-module-name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 选课中心 ")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/practice",
          class: "top-bar-module-name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 练习刷题 ")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/talking",
          class: "top-bar-module-name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" AI口语 ")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/teacher_displays",
          class: "top-bar-module-name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 名师介绍 ")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/my_courses",
          class: "top-bar-module-name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 个人中心 ")
          ]),
          _: 1
        }),
        (_unref(tenant) && _unref(tenant).showVisitData === true)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/statistics",
              class: "top-bar-module-name"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 数据统计 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_input, {
          size: "default",
          placeholder: "输入课程名字",
          modelValue: topbarSearchText.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((topbarSearchText).value = $event)),
          onKeyup: _withKeys(onEnter, ["enter","native"])
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: _unref(Search),
              onClick: _withModifiers(onEnter, ["stop"])
            }, null, 8, ["icon", "onClick"])
          ]),
          _: 1
        }, 8, ["modelValue", "onKeyup"])
      ]),
      _createElementVNode("div", null, [
        (_unref(currentUser))
          ? (_openBlock(), _createBlock(_component_el_dropdown, {
              key: 0,
              trigger: "click"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_avatar, {
                    size: 30,
                    src: _unref(currentUser) ? _unref(currentUser).avatar : '',
                    onError: _cache[1] || (_cache[1] = () => true)
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["src"]),
                  (_unref(currentUser))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(currentUser).name), 1),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ArrowDown))
                            ]),
                            _: 1
                          })
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { onClick: goMyCourseView }, {
                      default: _withCtx(() => [
                        _createTextVNode("收藏的课程")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, { onClick: goProfileView }, {
                      default: _withCtx(() => [
                        _createTextVNode("个人设置")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_divider, { style: {"margin":"5px 0"} }),
                    _createVNode(_component_el_dropdown_item, { onClick: goGetBackPasswordView }, {
                      default: _withCtx(() => [
                        _createTextVNode("修改密码")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, { onClick: logout }, {
                      default: _withCtx(() => [
                        _createTextVNode("退出登录")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_avatar, {
              key: 1,
              size: 30,
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (loginViewShow.value = true)),
              onError: _cache[3] || (_cache[3] = () => true)
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }))
      ])
    ])
  ]))
}
}

})